// @ts-nocheck
import CmsLibraryReducer, {
    CmsLibraryDataActions,
} from "@store/Framework/Store/Store/Data/CmsLibrary/CmsLibraryReducer";
import ValveConfiguratorReducer, {
    ValveConfiguratorDataActions,
} from "@store/Framework/Store/Store/Data/ValveConfigurator/ValveConfiguratorReducer";
import { combineReducers } from "redux";

const dataReducers = {
    cmsLibrary: CmsLibraryReducer,
    valveConfigurator: ValveConfiguratorReducer,
};

export type StoreDataActions = CmsLibraryDataActions | ValveConfiguratorDataActions;

const dataReducer = combineReducers(dataReducers as any);
export default dataReducer;
